import { all, put, takeLatest } from 'redux-saga/effects';
import actions from '../../../utils/actions';
import { setWatchedVideosProgress } from './actions';
import api from '../../../services/api';
import { defaultErrorHandler } from '../../utilities';
import { makeIdsList, splitListInBatches, translate } from '../../../utils/functions';
import langs from '../../../assets/i18n/constants';

function* getWatchedVideosProgress({ payload }) {
    try {
        const idsList = makeIdsList(payload);
        const splittedIdsList = splitListInBatches(idsList, 50);
        let progressList = [];

        for (let i = 0; i < splittedIdsList.length; i += 1) {
            const { progress } = yield api.getWatchedVideosProgress(splittedIdsList[i]);
            yield progressList = [...progressList, ...progress];
        }

        yield put(setWatchedVideosProgress(progressList));
    } catch (error) {
        defaultErrorHandler(error, { default: translate(langs.FAIL_TO_LOAD_VIDEO_PROGRESS) });
    }
}

export default all([
    takeLatest(actions.ROOM_GET_PROGRESS, getWatchedVideosProgress),
]);
